import React, { useCallback, useContext, useEffect, useState } from "react";

import { InputText, PageControl, TabSheet } from "../../../../components";

import { Grid, Button } from "@material-ui/core";
import { AppContext } from "../../../../App";

import { AppOptionsContext } from "../../../../components/main/main";
import ApiControllingArea from "../../../../api/accounting/controllingArea";
import { ControllingAreaValidate } from "../validates";
import CostCentersChange from "../costCentersChange";

const initialValues = {
    id: "",
    name: "",
};

export default function ControllingAreaChange({ id, onLoadRecord, onFinalize, showOptions }) {
    const { setLoading, showMessageError, showMessageInfo } = useContext(AppContext);
    const { setOptions } = useContext(AppOptionsContext);

    const [tabIndex, setTabIndex] = useState(0);

    const [controllingArea, setControllingArea] = useState([]);
    const [costCenters, setCostCenters] = useState([]);

    useEffect(() => {
        loadRecord(id);
    }, [id]);

    const loadRecord = async (id) => {
        if (!id || id === 0) return;

        setLoading(true);

        try {
            const result = await ApiControllingArea().apiDefault.findId(id, { associates: ["cost_centers"] });

            if (!result.status) {
                showMessageError(result.message);
                return;
            }

            setControllingArea(result.data);
            setCostCenters(result.data.cost_centers || []);

            onLoadRecord();
        } catch (e) {
            showMessageError(e.message);
        } finally {
            setLoading(false);
        }
    };

    const onClearRecord = () => {
        setControllingArea(initialValues);
        setCostCenters([]);

        if (id) {
            onFinalize(false);
        }
    };

    const onSave = useCallback(
        async (controllingArea, costCenters) => {
            const controllingAreaApply = {
                name: controllingArea.name,
                cost_centers: [],
            };

            controllingAreaApply.cost_centers = (costCenters || []).map((rec) => {
                return {
                    cost_center_code: rec.cost_center_code,
                    name: rec.name,
                    reference: rec.reference || null,
                };
            });

            // Validate
            const validate = await ApiControllingArea().apiDefault.validate(ControllingAreaValidate(), controllingAreaApply);
            if (!validate.status) {
                showMessageError(validate.message);
                return;
            }

            setLoading(true);
            try {
                let response = {};

                if (id) {
                    response = await ApiControllingArea().apiDefault.update(id, controllingAreaApply);
                } else {
                    response = await ApiControllingArea().apiDefault.creates(controllingAreaApply);
                }

                if (!response.status) {
                    showMessageError(response.message);
                    return;
                }

                showMessageInfo("Registro atualizado com sucesso");

                onClearRecord();
                onFinalize(true);
            } finally {
                setLoading(false);
            }
        },
        [id, controllingArea, costCenters]
    );

    useEffect(() => {
        if (showOptions) {
            setOptions(
                <>
                    <Button
                        style={{ float: "left", marginTop: "5px", marginBottom: "5px" }}
                        size="small"
                        variant="contained"
                        color="secondary"
                        onClick={() => onClearRecord()}
                    >
                        {id ? "Cancelar" : "Limpar tela"}
                    </Button>
                    <Button
                        style={{ float: "left", marginTop: "5px", marginBottom: "5px", marginLeft: "5px" }}
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={() => onSave(controllingArea, costCenters)}
                    >
                        Gravar
                    </Button>
                </>
            );
        }
    }, [showOptions, controllingArea, costCenters, id]);

    return (
        <>
            <Grid container spacing={1}>
                <Grid item xs={12} sm={7}>
                    <InputText
                        required
                        label="Nome"
                        value={controllingArea.name}
                        onChangeValue={(e) => setControllingArea({ ...controllingArea, name: e.target.value })}
                    />
                </Grid>
            </Grid>
            <PageControl style={{ marginTop: "10px" }} tabindex={tabIndex} onchangetab={(index) => setTabIndex(index)}>
                <TabSheet label="Centros de Custo">
                    <CostCentersChange costCenters={costCenters} setCostCenters={setCostCenters} id={id || 0} name={controllingArea.name} />
                </TabSheet>
            </PageControl>
        </>
    );
}
